<template>
  <div class="details-section">
    <div class="container">
      <div class="details-content">
        <h2 class="u-text-center u-p-l-20 u-p-r-20">{{info.title}}</h2>
        <div class="u-text-center u-font-16 cl_333">
          <p>{{ (new Date(info.create_time*1000)).toLocaleString() }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;浏览次数：{{info.views_count}}</p>
        </div>
        <el-divider></el-divider>
        <div v-html="info.content"></div>
        <el-divider></el-divider>
        <div class="nav-container">
          <div class="nav-item prev-item" @click="goPrev">
            <span class="nav-arrow"><i class="el-icon-arrow-left"></i></span>
            <span class="nav-text">上一篇：{{ prev.title || '没有更多了' }}</span>
          </div>
          <div class="nav-item next-item" @click="goNext">
            <span class="nav-text">下一篇：{{ next.title || '没有更多了' }}</span>
            <span class="nav-arrow"><i class="el-icon-arrow-right"></i></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { evaluateAnswerDetail } from '@/api/index'

export default {
  data() {
    return {
      id: this.$route.query.id,
      info: {},
      prev: {},
      next: {}
    }
  },
  mounted() {
    console.log(this.id)
    this.getDetails()
  },
   watch: {
    // 监听路由参数变化，当商品ID改变时重新加载数据
    '$route': {
      handler(newRoute) {
        if (newRoute.query.id) {
          this.id = newRoute.query.id
          this.getDetails()
        }
      },
      immediate: true
    }
  },
  methods: {
    getDetails() {
      evaluateAnswerDetail({
        id: this.id
      }).then(res => {
        if (res.code === 1) {
          this.info = res.data
          this.prev = res.data.prev || ''
          this.next = res.data.next || ''
        }
      })
    },
     goPrev() {
      if (this.prev.id) {
        this.$router.push({
          path: '/answerDetails',
          query: {
            id: this.prev.id
          }
        })
      } else {
        this.$message({
          message: '没有更多了',
          type: 'info'
        })
      }
    },
    goNext() {
      if (this.next.id) {
        this.$router.push({
          path: '/answerDetails',
          query: {
            id: this.next.id
          }
        })
      } else {
        this.$message({
          message: '没有更多了',
          type: 'info'
        })
      }
    },
  }
}
</script>

<style scoped>
.details-section{
  padding: 60px 0;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
.details-content{
  padding: 50px;
  background: #FFFFFF;
  box-shadow: 0px 3px 8px 1px rgba(60,97,135,0.05);
  border-radius: 8px 8px 8px 8px;
}
/* 上一篇下一篇导航样式 */
.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  color: #1B5AFF;
}

.nav-item {
  font-size: 16px;
  display: flex;
  align-items: center;
  width: 48%; /* 各占一半宽度，留一点间距 */
  cursor: pointer;
  transition: color 0.3s;
}

.nav-item:hover {
  /* font-weight: bold; */
  color: #1B5AFF;
}

.prev-item {
  justify-content: flex-start;
}

.next-item {
  justify-content: flex-end;
  text-align: right;
}

.nav-arrow {
  margin: 0 8px;
}

.nav-text {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>